<template>
  <div class="col p-0 text-center">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" />
    <div class="row d-flex align-items-center flex-column">
      <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-1"></div>
      <div class="col-md-1 col-lg-2"></div>
      <div class="col-12 col-md-10 col-lg-8">
        <h2 class="" v-html=" focus.paragraphe1 ? focus.paragraphe1.texte : '' "></h2>
        <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''" alt="" class="img-fluid lozad">
      </div>
      <div class="col-md-1 col-lg-2"></div>
    </div>
    <div class="row d-flex align-items-center flex-column">
      <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-5"></div>
      <div class="col-md-1 col-lg-2"></div>
      <div class="col-12 col-md-10 col-lg-8">
        <h2 v-html=" focus.paragraphe2 ? focus.paragraphe2.titre : '' "></h2>
        <div v-html=" focus.paragraphe2 ? focus.paragraphe2.texte : '' "></div>
        <h2 v-html=" focus.paragraphe3 ? focus.paragraphe3.titre : '' "></h2>
        <div v-html=" focus.paragraphe3 ? focus.paragraphe3.texte : '' "></div>
      </div>
      <div class="col-md-1 col-lg-2"></div>
    </div>
    <div class="bg-grey p-5 mt-2 d-flex align-items-center flex-column">
        <div style="height: 0.3rem; width: 7rem" class="bg-primary"></div>
        <h1>Quelle est votre situation ?</h1>
        <router-link class="text-uppercase text-dark" :to="{ name: 'EtudePatrimonialeForm' }">Accéder au formulaire -></router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getFocus } from '../../mixins/getFocus'

export default {
  name: 'EpargneRetraite',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      temoignages: {},
      focus: []
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Épargne / Retraite')
      .then(res => {
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
        this.greenHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>
